import { memo, useMemo } from 'react';
import DivTooltip from '@wg/wows-react-uikit/components/DivTooltip/DivTooltip';
import Tooltip from '@wg/wows-react-uikit/components/Tooltip/Tooltip';
import TooltipBody from '@wg/wows-react-uikit/components/Tooltip/TooltipBody';
import TooltipHeader from '@wg/wows-react-uikit/components/Tooltip/TooltipHeader';

import { t } from '~/helpers/localization';

import styles from './ClanHeader.module.scss';

interface ClanHeaderPreModerationHelpProps {
  preModeration?: string[] | null;
}

const ClanHeaderPreModerationHelp = ({ preModeration }: ClanHeaderPreModerationHelpProps) => {
  const isActive = useMemo(() => {
    if (!preModeration || preModeration.length === 0) {
      return false;
    }

    return preModeration.includes('name') || preModeration.includes('tag');
  }, [preModeration]);

  if (!isActive) {
    return null;
  }

  return (
    <div className={styles.ownPreModerationWrapper}>
      <DivTooltip
        tooltipBody={
          <Tooltip>
            <TooltipHeader isBold={true}>{t('Профиль вашего клана находится на премодерации')}</TooltipHeader>
            <TooltipBody>
              {t('Название и тег вашего клана обновятся, как только они будут одобрены модератором.')}
            </TooltipBody>
          </Tooltip>
        }
      >
        <div className={styles.ownPreModeration}></div>
      </DivTooltip>
    </div>
  );
};

export default memo(ClanHeaderPreModerationHelp);
